import { ArrowRight, Clock } from 'lucide-react';

const BlogPage = () => {
  return (
    <div className="pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6">
              The ShiftCheck <span className="text-primary-500">Blog</span>
            </h1>
            <p className="text-xl text-gray-500 leading-relaxed">
              Insights, best practices, and stories from the world of restaurant operations.
            </p>
          </div>
        </div>
      </section>

      {/* Coming Soon */}
      <section className="py-20 bg-gray-50 border-y border-gray-200">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-2xl mx-auto text-center bg-white rounded-2xl border border-gray-200 shadow-lg p-12">
            <div className="w-16 h-16 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center mx-auto mb-6 border border-primary-100">
              <Clock size={28} />
            </div>
            <h2 className="text-2xl font-extrabold text-gray-900 mb-4">Blog Coming Soon</h2>
            <p className="text-gray-600 leading-relaxed">
              We're focused on building ShiftCheck and working with our first restaurants right now. Once we have real lessons and stories worth sharing, you'll find them here.
            </p>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Subscribe to Our Newsletter</h2>
            <p className="text-gray-600 mb-8">
              Get the latest restaurant operations tips and ShiftCheck updates delivered to your inbox.
            </p>
            <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-primary-500 text-white rounded-lg font-bold hover:bg-primary-600 transition-colors flex items-center justify-center gap-2"
              >
                Subscribe
                <ArrowRight size={16} />
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
